(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoController', InvoiceInfoController);

    InvoiceInfoController.$inject = ['$scope', '$state', 'InvoiceInfo', 'InvoiceInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$rootScope', '$uibModal', 'Principal', 'DialogService', 'InvoiceInfoCustom', '$mdDialog', 'QueryParamsService'];

    function InvoiceInfoController($scope, $state, InvoiceInfo, InvoiceInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants, $rootScope, $uibModal, Principal, DialogService, InvoiceInfoCustom, $mdDialog, QueryParamsService) {

        var vm = this;

        // vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchKeyPress = searchKeyPress;


        vm.editInvoiceInfo = editInvoiceInfo;
        vm.searchInvoiceInfos = search;
        vm.newInvoiceInfo = newInvoiceInfo;
        vm.clearSearch = clearSearch;
        vm.findStatusStyle = findStatusStyle;
        vm.filterQuery = {};

        //must set in cache
        vm.pageSize = 10;
        vm.pageSizeList = [10, 20, 50];
        vm.isSearching = false;
        vm.pageSizeChanged = pageSizeChanged;
        vm.showEducation = showEducation;
        $scope.filters = QueryParamsService.getFilters();
        
        loadData();

        // loadAll_paging();


        function loadData() {
            filterInvoiceInfo();
        }

        // function loadAll_paging() {

        //     if (pagingParams.search) {
        //         InvoiceInfoSearch.query({
        //             query: pagingParams.search,
        //             page: pagingParams.page - 1,
        //             size: paginationConstants.itemsPerPage,
        //             sort: sort()
        //         }, onSuccess, onError);
        //     } else {
        //         InvoiceInfoSearch.query({
        //             query: "",
        //             page: pagingParams.page - 1,
        //             size: paginationConstants.itemsPerPage,
        //             sort: sort()
        //         }, onSuccess, onError);
        //     }

        //     function sort() {
        //         var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        //         if (vm.predicate !== 'id') {
        //             result.push('id');
        //         }
        //         return result;
        //     }

        //     function onSuccess(data, headers) {
        //         vm.links = ParseLinks.parse(headers('link'));
        //         vm.totalItems = headers('X-Total-Count');
        //         vm.queryCount = vm.totalItems;
        //         vm.invoiceInfos = data;
        //         vm.page = pagingParams.page;
        //     }

        //     function onError(error) {
        //         AlertService.error(error.data.message);
        //     }
        // }

        // function loadPage(page) {
        //     vm.page = page;
        //     vm.transition();
        // }

        function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     search: vm.currentSearch
            // });
            if (vm.filterQuery.searchMode)
                getInvoiceInfoPagesByQuery(vm.filterQuery);
            else
                getInvoiceInfoPagesByQuery();

        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.filterQuery.pageNumber = 0;
            vm.transition();
        }


        function search() {

            loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();

        }


        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                vm.advancedSearch();
            }
        }


        function clearSearch() {
            QueryParamsService.removeFilter('searchText')
            vm.filterQuery.searchText = null;
            filterInvoiceInfo_Global();
        }

        function newInvoiceInfo() {

            var result;

            result = Principal.hasSpecialFeatureAccess("invoice");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.go('supplierPanel-v2.newInvoiceInfo');
        }


        function editInvoiceInfo(invoiceInfo) {
            if (invoiceInfo.status == 'TEMP')
                $state.go('supplierPanel-v2.editInvoiceInfo', {id: invoiceInfo.id});
            if (invoiceInfo.status == 'UNPAID' || invoiceInfo.status == 'SETTLEMENT' || invoiceInfo.status == 'VOID')
                $state.go('supplierPanel-v2.invoiceInfoDetail', {id: invoiceInfo.id});

        }

        function findStatusStyle(status) {
            return "invoice-info-status-box invoice-status-" + status;
        }


        vm.advancedSearch = function () {
            QueryParamsService.updateFilter('searchText', vm.filterQuery.searchText)
            clear();
            vm.filterQuery.searchMode = true;
            filterInvoiceInfo();
        }

        function pageSizeChanged() {
            QueryParamsService.updateFilter('pageSize', vm.pageSize)
            clear();
            filterOrderBag();
        }

        function getInvoiceInfoPagesByQuery(customFilter) {

            if (vm.isSearching)
                return;

            vm.isSearching = true;
            var filterQuery = vm.filterQuery;
            if (customFilter)
                filterQuery = customFilter;

            if (vm.page)
                filterQuery.pageNumber = vm.page - 1;
            else
                filterQuery.pageNumber = 0;


            filterQuery.pageSize = vm.pageSize; // paginationConstants.itemsPerPage;
            // paginationConstants.itemsPerPage = vm.pageSize;

            InvoiceInfoCustom.searchInvoiceInfoByQueryPage().save(filterQuery, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.invoiceInfos = data;
                vm.isSearching = false;

                gotToTop();
                // vm.page = vm.filterQuery.pageNumber+1;
            }

            function onError(error) {
                vm.isSearching = false;
                AlertService.error(error.data.message);
            }
        }


        function gotToTop() {
            // window.scroll(0, 0);
            if (vm.page > 1) {
                document.getElementsByClassName("topOfList")[0].scrollIntoView();
                document.getElementsByClassName("topOfListMobile")[0].scrollIntoView();
            }
        }

        function filterInvoiceInfo_Global() {
            vm.filterQuery.searchMode = true;
            filterInvoiceInfo();
            clear();

        }

        function filterInvoiceInfo(customFilter) {

            if (vm.isSearching)
                return;
            getQueryParams()
            getInvoiceInfoPagesByQuery(customFilter);
        }

        //Filter Dialog
        var ShowFilterDialogController = function ($scope, $mdDialog, dialogData, $mdSelect) {
            var $ctrl = this;
            $ctrl.data = dialogData;
            $ctrl.okModal = okModal;
            $ctrl.closeModal = closeModal;
            $ctrl.clearFilter = clearFilter;


            //for closing the select box
            document.body.onclick = function (e) {
                $mdSelect.hide();
            }

            function okModal() {
                $mdDialog.hide($ctrl.data);
            }

            function closeModal() {
                $mdDialog.cancel();
            }

            function clearFilter() {
                $ctrl.data.filterQuery = {};
            }

        };
        ShowFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', '$mdSelect'];

        vm.showFilterDialog = function () {

            var dialogData_ = {};
            dialogData_.statusList = ["TEMP", "SETTLEMENT", "UNPAID", "VOID"];
            dialogData_.filterQuery = vm.filterQuery;


            $mdDialog.show({
                locals: {dialogData: dialogData_},
                controller: ShowFilterDialogController,
                templateUrl: 'app/entities/invoice-info/filter-invoice-info-list-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: dialogData_,
                clickOutsideToClose: true,
                size: 'lg',
                fullscreen: false

            })
                .then(function (data) {
                    setFilterQuery(data.filterQuery, true);
                    QueryParamsService.updateFilter('filterQuery', encodeURIComponent(JSON.stringify(data.filterQuery)))
                    vm.advancedSearch();
                }, function () {
                });
        }

        function setFilterQuery(filter,  ignorSearchText) {
            var shallowFilter = filter
            if(ignorSearchText &&  shallowFilter.searchText) delete shallowFilter.searchText
            angular.extend(vm.filterQuery, filter);
            countFilters();
        }

        function countFilters() {

            vm.filterCount = 0;
            var date = new Date();

            if (vm.filterQuery.fromDate)
                vm.filterCount++;
            if (vm.filterQuery.toDate)
                vm.filterCount++;
            if (vm.filterQuery.status && vm.filterQuery.status.length > 0)
                vm.filterCount++;
            if(vm.filterCount < 1) 
                QueryParamsService.removeFilter('filterQuery')
        }
        function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                        return '<div id="51442125157"><script type="text/JavaScript" src="https://www.aparat.com/embed/ees396e?data[rnddiv]=51442125157&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>';
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }

        function getQueryParams() {
            var newFilters = QueryParamsService.getFilters();
            // if(newFilters.page){
            //     vm.filterQuery.pageNumber = newFilters.page;
            //     vm.page = parseInt(newFilters.page);
            // }
        
            if (newFilters.page) {
                vm.filterQuery.pageNumber = parseInt(newFilters.page, 10) - 1;
                vm.page = parseInt(newFilters.page, 10);
                }
       
            if(newFilters.pageSize){
                vm.filterQuery.pageSize = newFilters.pageSize;
                vm.pageSize = newFilters.pageSize;
            }
            if(newFilters.searchText){
                vm.filterQuery.searchText = newFilters.searchText;
            }
            if(newFilters.fromDate){
                vm.filterQuery.fromDate = newFilters.fromDate;
            }
            if(newFilters.toDate){
                vm.filterQuery.toDate = newFilters.toDate;
            }
            if(newFilters.servantIds){
                vm.filterQuery.servantIds = newFilters.servantIds;
            }
            if(newFilters.serviceItemIds){
                vm.filterQuery.serviceItemIds = newFilters.serviceItemIds;
            }
            if(newFilters.status){
                vm.filterQuery.status = newFilters.status;
            }
            if(newFilters.filterQuery) {
                var newF = angular.extend(JSON.parse(decodeURIComponent(newFilters.filterQuery)), vm.filterQuery);
                setFilterQuery(newF)
            }
        }


        //..................................

    }
})();
